export class SetInstallationsPackagesReqData {
    installationNames: string[] = [];
    enabledPackageIds: number[] = [];
    disabledPackageIds: number[] = [];
}
